import cx from "classnames";

export type SwitchItemProps<T> = {
  value: T;
  type?: string;
  selected?: boolean;
  children?: string | JSX.Element[] | JSX.Element;
  className?: string;
};

// Value is used in Switch parent
const SwitchItem = <T,>({
  // value,
  children,
  selected,
  type = "primary",
  className,
}: SwitchItemProps<T>) => {
  const classNames = cx(
    "inline-block font-medium text-sm",
    {
      "text-tim-primary": selected && type === "primary",
      "text-gray-500": !selected,
    },
    className
  );

  return <div className={classNames}>{children}</div>;
};

export default SwitchItem;
